export const BenzingaJapanLogo = () => {
  return <img alt="Benzinga Japan" height="53" src="/next-assets/images/logos/bz-logo-japan.webp" width="501" />;
};

export default BenzingaJapanLogo;
